import React, {useEffect, useRef, useState} from 'react';
import {DynamicDataSheetGrid, keyColumn} from "react-datasheet-grid";
import {createAddRowsComponent, onCopyValueDateTracking, onCopyValueText} from "./TableOrderUtils";
import {
    getIndicatorById4FakeTable,
    getOrderStatusName,
    shiftPlanDates,
    shiftPlanesDatesFake
} from "../../Orders/OrderCommon";
import {cloneDeep, get, isEqual, set} from "lodash";
import {getExistLangValue, getLangInStorage, translate} from "../../../utils/utils";
import {VEHICLE_BODY_TYPE} from "../../../constants/staticData";
import orderDeliveryService from "../../../services/orderDeliveryService";
import OrderDeliveryService from "../../../services/orderDeliveryService";
import {Popover, PopoverBody} from "reactstrap";
import {FormattedMessage} from "react-intl";
import moment from "moment";
import FlashStore from "../../../stores/flashStore";
import AppStore from "../../../stores/appStore";
import {DATE_FORMAT} from "../../../constants/global";
import {Modal} from "../Modal";
import FontAwesome from "react-fontawesome";
import {Preloader} from "../Preloader";


const TrackingDateTableEdit = ({id, activeColumn, activeRow}) => {

    const tableEditRef = useRef(null)
    const [columns, setColumns] = useState([])
    const [columnsModal, setColumnsModal] = useState([])
    const [data, setData] = useState([])
    const [fake, setFake] = useState(false)
    const [deliveryTracking, setDeliveryTracking] = useState(null)
    const [isModal, setIsModal] = useState(false)
    const [usedSetActive, setUsedSetActive] = useState(false)
    const [blockEdit, setBlockEdit] = useState(false)

    useEffect(() => {
        if (activeColumn && columns?.length > 0 && usedSetActive === false) {
            setTimeout(()=>{
                tableEditRef?.current?.setActiveCell({col: activeColumn, row: activeRow})
                setUsedSetActive(true)
            }, 200)

        }
    }, [activeColumn, columns, usedSetActive])

    const onChange = (value, operations) => {

    }

    const checkDisabledDate = (name = '', index, rowData) => {

        if (name.includes("Fact") || name.includes("invoice"))
            return false

        const currentRow = data[index];
        const prepareItemsFact = []
        const indexCurrent = Object.keys(currentRow).indexOf(name);
        if (currentRow) {
            let index = 0;
            for (let key of Object.keys(currentRow)) {
                if (index > indexCurrent) {
                    index++;
                    if (key.includes("orderId") || key.includes("status") || key.includes("nameCargo") || key.includes("idCargo"))
                        continue;
                    const element = get(currentRow, key);
                    if (element) {
                        if (element?.path?.includes(".fact")) {
                            prepareItemsFact.push(element);
                        }
                    }
                } else {
                    index++
                }
            }
            for (let item of prepareItemsFact) {
                if (item?.value) {
                    return true
                }
            }
        }
        return false

    }

    const updateRow = async (rowData, index) => {
        const buildTrackingInfo = async () => {
            setBlockEdit(true)
            const idCargo = rowData?.idCargo;
            const trackingInfo = rowData?.trackingInfo;
            orderDeliveryService.sendLogisticBlock(id, trackingInfo, idCargo, false).then(async res => {
                if (res.code === 200) {
                    await prepareItems(res.data)
                    FlashStore.successNow(translate({id: 'common.save.success'}), true);
                } else {
                    FlashStore.errorNow(translate({id: 'service.serverError'}), true);
                }
                setBlockEdit(false)
            })
        }
        await buildTrackingInfo()
    }


    const prepareTrackingInfo = async (trackingInfo, id, status, indexGlobal, fake) => {
        const result = {};
        if (trackingInfo?.transitPoints?.length > 0) {
            let index = 0;
            for (let transitPoint of trackingInfo?.transitPoints) {
                switch (transitPoint.typeTracking) {

                    case "POINT_OF_PICKUP":
                        set(result, `pointOfPickupReadyPlan.value`, transitPoint.ready?.plan);
                        set(result, `pointOfPickupReadyPlan.name`, transitPoint.name);
                        set(result, `pointOfPickupReadyPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].ready.plan`);
                        set(result, `pointOfPickupReadyPlan.fake`, true);

                        set(result, `pointOfPickupReadyFact.value`, transitPoint.ready?.fact);
                        set(result, `pointOfPickupReadyFact.name`, transitPoint.name);
                        set(result, `pointOfPickupReadyFact.indicator`, getIndicatorById4FakeTable(transitPoint.ready?.plan, transitPoint.ready?.fact));
                        set(result, `pointOfPickupReadyFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].ready.fact`);
                        set(result, `pointOfPickupReadyFact.fake`, true);

                        set(result, `pointOfPickupLoadPlan.value`, transitPoint.load?.plan);
                        set(result, `pointOfPickupLoadPlan.name`, transitPoint.name);
                        set(result, `pointOfPickupLoadPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].load.plan`);
                        set(result, `pointOfPickupLoadPlan.fake`, true);

                        set(result, `pointOfPickupLoadFact.value`, transitPoint.load?.fact);
                        set(result, `pointOfPickupLoadFact.name`, transitPoint.name);
                        set(result, `pointOfPickupLoadFact.indicator`, getIndicatorById4FakeTable(transitPoint.load?.plan, transitPoint.load?.fact));
                        set(result, `pointOfPickupLoadFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].load.fact`);
                        set(result, `pointOfPickupLoadFact.fake`, true);

                        set(result, `pointOfPickupDeparturePlan.value`, transitPoint.departure?.plan);
                        set(result, `pointOfPickupDeparturePlan.name`, transitPoint.name);
                        set(result, `pointOfPickupDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.plan`);
                        set(result, `pointOfPickupDeparturePlan.fake`, true);

                        set(result, `pointOfPickupDepartureFact.value`, transitPoint.departure?.fact);
                        set(result, `pointOfPickupDepartureFact.name`, transitPoint.name);
                        set(result, `pointOfPickupDepartureFact.indicator`, getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact));
                        set(result, `pointOfPickupDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.fact`);
                        set(result, `pointOfPickupDepartureFact.fake`, true);
                        index++;
                        break;
                    case "INVOICE_DATE":
                        set(result, `invoiceDate.value`, transitPoint.singleDate);
                        set(result, `invoiceDate.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].singleDate`);
                        set(result, `invoiceDate.fake`, true);
                        index++;
                        break;
                    case "INVOICE_PAYMENT_DATE":
                        set(result, `invoicePaymentDate.value`, transitPoint.singleDate);
                        set(result, `invoicePaymentDate.indicator`, getIndicatorById4FakeTable(trackingInfo.transitPoints?.filter(tp => tp.typeTracking === "INVOICE_DATE")?.singleDate, transitPoint.singleDate));
                        set(result, `invoicePaymentDate.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].singleDate`);
                        set(result, `invoicePaymentDate.fake`, true);
                        index++;
                        break;
                    case "POINT_OF_TRANSIT":
                        set(result, `transitPoint${index}ArrivalPlan.value`, transitPoint.arrival?.plan);
                        set(result, `transitPoint${index}ArrivalPlan.name`, transitPoint.name);
                        set(result, `transitPoint${index}ArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.plan`);
                        set(result, `transitPoint${index}ArrivalPlan.fake`, true);

                        set(result, `transitPoint${index}ArrivalFact.value`, transitPoint.arrival?.fact);
                        set(result, `transitPoint${index}ArrivalFact.name`, transitPoint.name);
                        set(result, `transitPoint${index}ArrivalFact.indicator`, getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact));
                        set(result, `transitPoint${index}ArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.fact`);
                        set(result, `transitPoint${index}ArrivalFact.fake`, true);

                        set(result, `transitPoint${index}DeparturePlan.value`, transitPoint.departure?.plan);
                        set(result, `transitPoint${index}DeparturePlan.name`, transitPoint.name);
                        set(result, `transitPoint${index}DeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.plan`);
                        set(result, `transitPoint${index}DeparturePlan.fake`, true);

                        set(result, `transitPoint${index}DepartureFact.value`, transitPoint.departure?.fact);
                        set(result, `transitPoint${index}DepartureFact.name`, transitPoint.name);
                        set(result, `transitPoint${index}DepartureFact.indicator`, getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact));
                        set(result, `transitPoint${index}DepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.fact`);
                        set(result, `transitPoint${index}DepartureFact.fake`, true);
                        index++;
                        break;
                    case "POINT_OF_ARRIVAL":
                        set(result, `pointOfArrivalArrivalPlan.value`, transitPoint.arrival?.plan);
                        set(result, `pointOfArrivalArrivalPlan.name`, transitPoint.name);
                        set(result, `pointOfArrivalArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.plan`);
                        set(result, `pointOfArrivalArrivalPlan.fake`, true);

                        set(result, `pointOfArrivalArrivalFact.value`, transitPoint.arrival?.fact);
                        set(result, `pointOfArrivalArrivalFact.name`, transitPoint.name);
                        set(result, `pointOfArrivalArrivalFact.indicator`, getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact));
                        set(result, `pointOfArrivalArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.fact`);
                        set(result, `pointOfArrivalArrivalFact.fake`, true);

                        set(result, `pointOfArrivalReceiptOfDocumentsPlan.value`, transitPoint.receiptOfDocuments?.plan);
                        set(result, `pointOfArrivalReceiptOfDocumentsPlan.name`, transitPoint.name);
                        set(result, `pointOfArrivalReceiptOfDocumentsPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].receiptOfDocuments.plan`);
                        set(result, `pointOfArrivalReceiptOfDocumentsPlan.fake`, true);

                        set(result, `pointOfArrivalReceiptOfDocumentsFact.value`, transitPoint.receiptOfDocuments?.fact);
                        set(result, `pointOfArrivalReceiptOfDocumentsFact.name`, transitPoint.name);
                        set(result, `pointOfArrivalReceiptOfDocumentsFact.indicator`, getIndicatorById4FakeTable(transitPoint.receiptOfDocuments?.plan, transitPoint.receiptOfDocuments?.fact));
                        set(result, `pointOfArrivalReceiptOfDocumentsFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].receiptOfDocuments.fact`);
                        set(result, `pointOfArrivalReceiptOfDocumentsFact.fake`, true);

                        set(result, `pointOfArrivalDeparturePlan.value`, transitPoint.departure?.plan);
                        set(result, `pointOfArrivalDeparturePlan.name`, transitPoint.name);
                        set(result, `pointOfArrivalDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.plan`);
                        set(result, `pointOfArrivalDeparturePlan.fake`, true);

                        set(result, `pointOfArrivalDepartureFact.value`, transitPoint.departure?.fact);
                        set(result, `pointOfArrivalDepartureFact.name`, transitPoint.name);
                        set(result, `pointOfArrivalDepartureFact.indicator`, getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact));
                        set(result, `pointOfArrivalDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.fact`);
                        set(result, `pointOfArrivalDepartureFact.fake`, true);

                        index++;
                        break;
                    case "POINT_OF_CUSTOMS_CLEARANCE":
                        set(result, `customsClearanceArrivalPlan.value`, transitPoint.arrival?.plan);
                        set(result, `customsClearanceArrivalPlan.name`, transitPoint.name);
                        set(result, `customsClearanceArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.plan`);
                        set(result, `customsClearanceArrivalPlan.fake`, true);

                        set(result, `customsClearanceArrivalFact.value`, transitPoint.arrival?.fact);
                        set(result, `customsClearanceArrivalFact.name`, transitPoint.name);
                        set(result, `customsClearanceArrivalFact.indicator`, getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact));
                        set(result, `customsClearanceArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.fact`);
                        set(result, `customsClearanceArrivalFact.fake`, true);

                        set(result, `customsClearanceDeparturePlan.value`, transitPoint.departure?.plan);
                        set(result, `customsClearanceDeparturePlan.name`, transitPoint.name);
                        set(result, `customsClearanceDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.plan`);
                        set(result, `customsClearanceDeparturePlan.fake`, true);

                        set(result, `customsClearanceDepartureFact.value`, transitPoint.departure?.fact);
                        set(result, `customsClearanceDepartureFact.name`, transitPoint.name);
                        set(result, `customsClearanceDepartureFact.indicator`, getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact));
                        set(result, `customsClearanceDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.fact`);
                        set(result, `customsClearanceDepartureFact.fake`, true);

                        index++;
                        break;
                    case "POINT_OF_DESTINATION":
                        set(result, `pointOfDestinationArrivalPlan.value`, transitPoint.arrival?.plan);
                        set(result, `pointOfDestinationArrivalPlan.name`, transitPoint.name);
                        set(result, `pointOfDestinationArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.plan`);
                        set(result, `pointOfDestinationArrivalPlan.fake`, true);

                        set(result, `pointOfDestinationArrivalFact.value`, transitPoint.arrival?.fact);
                        set(result, `pointOfDestinationArrivalFact.name`, transitPoint.name);
                        set(result, `pointOfDestinationArrivalFact.indicator`, getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact))
                        set(result, `pointOfDestinationArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.fact`);
                        set(result, `pointOfDestinationArrivalFact.fake`, true);
                        if (transitPoint.departure) {
                            set(result, `pointOfDestinationDeparturePlan.value`, transitPoint.departure?.plan);
                            set(result, `pointOfDestinationDeparturePlan.name`, transitPoint.name);
                            set(result, `pointOfDestinationDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.plan`);
                            set(result, `pointOfDestinationDeparturePlan.fake`, true);

                            set(result, `pointOfDestinationDepartureFact.value`, transitPoint.departure?.fact);
                            set(result, `pointOfDestinationDepartureFact.name`, transitPoint.name);
                            set(result, `pointOfDestinationDepartureFact.indicator`, getIndicatorById4FakeTable(transitPoint.departure?.plan, transitPoint.departure?.fact))
                            set(result, `pointOfDestinationDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].departure.fact`);
                            set(result, `pointOfDestinationDepartureFact.fake`, true);
                        }
                        index++;
                        break;

                    case "POINT_OF_DELIVERY_TO_RECIPIENT":

                        set(result, `deliveryToRecipientArrivalPlan.value`, transitPoint.arrival?.plan);
                        set(result, `deliveryToRecipientArrivalPlan.name`, transitPoint.name);
                        set(result, `deliveryToRecipientArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.plan`);
                        set(result, `deliveryToRecipientArrivalPlan.fake`, true);

                        set(result, `deliveryToRecipientArrivalFact.value`, transitPoint.arrival?.fact);
                        set(result, `deliveryToRecipientArrivalFact.name`, transitPoint.name);
                        set(result, `deliveryToRecipientArrivalFact.indicator`, getIndicatorById4FakeTable(transitPoint.arrival?.plan, transitPoint.arrival?.fact))
                        set(result, `deliveryToRecipientArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.transitPoints[${index}].arrival.fact`);
                        set(result, `deliveryToRecipientArrivalFact.fake`, true);
                        index++;
                        break;
                }

            }
        } else {
            const pointOfPickup = trackingInfo?.pointOfPickup;
            let index = 0;
            if (pointOfPickup) {
                set(result, `pointOfPickupReadyPlan.value`, pointOfPickup.ready?.plan);
                set(result, `pointOfPickupReadyPlan.name`, pointOfPickup.name);
                set(result, `pointOfPickupReadyPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.ready.plan`);
                set(result, `pointOfPickupReadyPlan.fake`, false);

                set(result, `pointOfPickupReadyFact.value`, pointOfPickup.ready?.fact);
                set(result, `pointOfPickupReadyFact.name`, pointOfPickup.name);
                set(result, `pointOfPickupReadyFact.indicator`, getIndicatorById4FakeTable(pointOfPickup.ready?.plan, pointOfPickup.ready?.fact));
                set(result, `pointOfPickupReadyFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.ready.fact`);
                set(result, `pointOfPickupReadyFact.fake`, false);

                set(result, `pointOfPickupLoadPlan.value`, pointOfPickup.load?.plan);
                set(result, `pointOfPickupLoadPlan.name`, pointOfPickup.name);
                set(result, `pointOfPickupLoadPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.load.plan`);
                set(result, `pointOfPickupLoadPlan.fake`, false);

                set(result, `pointOfPickupLoadFact.value`, pointOfPickup.load?.fact);
                set(result, `pointOfPickupLoadFact.name`, pointOfPickup.name);
                set(result, `pointOfPickupLoadFact.indicator`, getIndicatorById4FakeTable(pointOfPickup.load?.plan, pointOfPickup.load?.fact));
                set(result, `pointOfPickupLoadFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.load.fact`);
                set(result, `pointOfPickupLoadFact.fake`, false);

                set(result, `pointOfPickupDeparturePlan.value`, pointOfPickup.departure?.plan);
                set(result, `pointOfPickupDeparturePlan.name`, pointOfPickup.name);
                set(result, `pointOfPickupDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.departure.plan`);
                set(result, `pointOfPickupDeparturePlan.fake`, false);

                set(result, `pointOfPickupDepartureFact.value`, pointOfPickup.departure?.fact);
                set(result, `pointOfPickupDepartureFact.name`, pointOfPickup.name);
                set(result, `pointOfPickupDepartureFact.indicator`, getIndicatorById4FakeTable(pointOfPickup.departure?.plan, pointOfPickup.departure?.fact));
                set(result, `pointOfPickupDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfPickup.departure.fact`);
                set(result, `pointOfPickupDepartureFact.fake`, false);
                index++;
            }
            const invoiceDate = trackingInfo?.invoiceDate;
            if (invoiceDate) {
                set(result, `invoiceDate.value`, invoiceDate.date?.date);
                set(result, `invoiceDate.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.invoiceDate.date.date`);
                set(result, `invoiceDate.fake`, false);
                index++;
            }
            const invoicePaymentDate = trackingInfo?.invoicePaymentDate;
            if (invoicePaymentDate) {
                set(result, `invoicePaymentDate.value`, invoicePaymentDate.date?.date);
                set(result, `invoicePaymentDate.indicator`, getIndicatorById4FakeTable(invoiceDate?.date?.date, invoicePaymentDate?.date?.date));
                set(result, `invoicePaymentDate.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.invoicePaymentDate.date.date`);
                set(result, `invoicePaymentDate.fake`, false);
                index++;
            }
            const pointOfOrigin = trackingInfo?.pointOfOrigin;
            if (pointOfOrigin) {
                set(result, `pointOfOriginArrivalPlan.value`, pointOfOrigin.arrival?.plan);
                set(result, `pointOfOriginArrivalPlan.name`, pointOfOrigin.name);
                set(result, `pointOfOriginArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfOrigin.arrival.plan`);
                set(result, `pointOfOriginArrivalPlan.fake`, true);

                set(result, `pointOfOriginArrivalFact.value`, pointOfOrigin.arrival?.fact);
                set(result, `pointOfOriginArrivalFact.name`, pointOfOrigin.name);
                set(result, `pointOfOriginArrivalFact.indicator`, getIndicatorById4FakeTable(pointOfOrigin.arrival?.plan, pointOfOrigin.arrival?.fact));
                set(result, `pointOfOriginArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfOrigin.arrival.fact`);
                set(result, `pointOfOriginArrivalFact.fake`, true);

                set(result, `pointOfOriginDeparturePlan.value`, pointOfOrigin.departure?.plan);
                set(result, `pointOfOriginDeparturePlan.name`, pointOfOrigin.name);
                set(result, `pointOfOriginDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfOrigin.departure.plan`);
                set(result, `pointOfOriginDeparturePlan.fake`, true);

                set(result, `pointOfOriginDepartureFact.value`, pointOfOrigin.departure?.fact);
                set(result, `pointOfOriginDepartureFact.name`, pointOfOrigin.name);
                set(result, `pointOfOriginDepartureFact.indicator`, getIndicatorById4FakeTable(pointOfOrigin.departure?.plan, pointOfOrigin.departure?.fact));
                set(result, `pointOfOriginDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfOrigin.departure.fact`);
                set(result, `pointOfOriginDepartureFact.fake`, true);
                index++;
            }
            const customsClearance = trackingInfo?.customsClearance;
            if (customsClearance) {
                set(result, `customsClearanceArrivalPlan.value`, customsClearance.arrival?.plan);
                set(result, `customsClearanceArrivalPlan.name`, customsClearance.name);
                set(result, `customsClearanceArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.customsClearance.arrival.plan`);
                set(result, `customsClearanceArrivalPlan.fake`, true);

                set(result, `customsClearanceArrivalFact.value`, customsClearance.arrival?.fact);
                set(result, `customsClearanceArrivalFact.name`, customsClearance.name);
                set(result, `customsClearanceArrivalFact.indicator`, getIndicatorById4FakeTable(customsClearance.arrival?.plan, customsClearance.arrival?.fact));
                set(result, `customsClearanceArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.customsClearance.arrival.fact`);
                set(result, `customsClearanceArrivalFact.fake`, true);

                set(result, `customsClearanceDeparturePlan.value`, customsClearance.departure?.plan);
                set(result, `customsClearanceDeparturePlan.name`, customsClearance.name);
                set(result, `customsClearanceDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.customsClearance.departure.plan`);
                set(result, `customsClearanceDeparturePlan.fake`, true);

                set(result, `customsClearanceDepartureFact.value`, customsClearance.departure?.fact);
                set(result, `customsClearanceDepartureFact.name`, customsClearance.name);
                set(result, `customsClearanceDepartureFact.indicator`, getIndicatorById4FakeTable(customsClearance.departure?.plan, customsClearance.departure?.fact));
                set(result, `customsClearanceDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.customsClearance.departure.fact`);
                set(result, `customsClearanceDepartureFact.fake`, true);
                index++;
            }
            const pointOfArrival = trackingInfo?.pointOfArrival;
            if (pointOfArrival) {
                set(result, `pointOfArrivalArrivalPlan.value`, pointOfArrival.arrival?.plan);
                set(result, `pointOfArrivalArrivalPlan.name`, pointOfArrival.name);
                set(result, `pointOfArrivalArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.arrival.plan`);
                set(result, `pointOfArrivalArrivalPlan.fake`, true);

                set(result, `pointOfArrivalArrivalFact.value`, pointOfArrival.arrival?.fact);
                set(result, `pointOfArrivalArrivalFact.name`, pointOfArrival.name);
                set(result, `pointOfArrivalArrivalFact.indicator`, getIndicatorById4FakeTable(pointOfArrival.arrival?.plan, pointOfArrival.arrival?.fact));
                set(result, `pointOfArrivalArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.arrival.fact`);
                set(result, `pointOfArrivalArrivalFact.fake`, true);

                set(result, `pointOfArrivalReceiptOfDocumentsPlan.value`, pointOfArrival.receiptOfDocuments?.plan);
                set(result, `pointOfArrivalReceiptOfDocumentsPlan.name`, pointOfArrival.name);
                set(result, `pointOfArrivalReceiptOfDocumentsPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.receiptOfDocuments.plan`);
                set(result, `pointOfArrivalReceiptOfDocumentsPlan.fake`, true);

                set(result, `pointOfArrivalReceiptOfDocumentsFact.value`, pointOfArrival.receiptOfDocuments?.fact);
                set(result, `pointOfArrivalReceiptOfDocumentsFact.name`, pointOfArrival.name);
                set(result, `pointOfArrivalReceiptOfDocumentsFact.indicator`, getIndicatorById4FakeTable(pointOfArrival.receiptOfDocuments?.plan, pointOfArrival.receiptOfDocuments?.fact));
                set(result, `pointOfArrivalReceiptOfDocumentsFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.receiptOfDocuments.fact`);
                set(result, `pointOfArrivalReceiptOfDocumentsFact.fake`, true);

                set(result, `pointOfArrivalDeparturePlan.value`, pointOfArrival.departure?.plan);
                set(result, `pointOfArrivalDeparturePlan.name`, pointOfArrival.name);
                set(result, `pointOfArrivalDeparturePlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.departure.plan`);
                set(result, `pointOfArrivalDeparturePlan.fake`, true);

                set(result, `pointOfArrivalDepartureFact.value`, pointOfArrival.departure?.fact);
                set(result, `pointOfArrivalDepartureFact.name`, pointOfArrival.name);
                set(result, `pointOfArrivalDepartureFact.indicator`, getIndicatorById4FakeTable(pointOfArrival.departure?.plan, pointOfArrival.departure?.fact));
                set(result, `pointOfArrivalDepartureFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfArrival.departure.fact`);
                set(result, `pointOfArrivalDepartureFact.fake`, true);
                index++;
            }
            const pointOfDestination = trackingInfo?.pointOfDestination;
            if (pointOfDestination) {
                set(result, `pointOfDestinationArrivalPlan.value`, pointOfDestination.arrival?.plan);
                set(result, `pointOfDestinationArrivalPlan.name`, pointOfDestination.name);
                set(result, `pointOfDestinationArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfDestination.arrival.plan`);
                set(result, `pointOfDestinationArrivalPlan.fake`, true);

                set(result, `pointOfDestinationArrivalFact.value`, pointOfDestination.arrival?.fact);
                set(result, `pointOfDestinationArrivalFact.name`, pointOfDestination.name);
                set(result, `pointOfDestinationArrivalFact.indicator`, getIndicatorById4FakeTable(pointOfDestination.arrival?.plan, pointOfDestination.arrival?.fact))
                set(result, `pointOfDestinationArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.pointOfDestination.arrival.fact`);
                set(result, `pointOfDestinationArrivalFact.fake`, true);
                index++;
            }
            const deliveryToRecipientDate = trackingInfo?.deliveryToRecipientDate;
            if (deliveryToRecipientDate) {
                set(result, `deliveryToRecipientArrivalPlan.value`, deliveryToRecipientDate.date?.plan);
                set(result, `deliveryToRecipientArrivalPlan.name`, deliveryToRecipientDate.name);
                set(result, `deliveryToRecipientArrivalPlan.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.deliveryToRecipientDate.date.plan`);
                set(result, `deliveryToRecipientArrivalPlan.fake`, true);

                set(result, `deliveryToRecipientArrivalFact.value`, deliveryToRecipientDate.date?.fact);
                set(result, `deliveryToRecipientArrivalFact.name`, deliveryToRecipientDate.name);
                set(result, `deliveryToRecipientArrivalFact.indicator`, getIndicatorById4FakeTable(deliveryToRecipientDate.date?.plan, deliveryToRecipientDate.date?.fact))
                set(result, `deliveryToRecipientArrivalFact.path`, `trackingInfoItems[${indexGlobal}].trackingInfo.deliveryToRecipientDate.date.fact`);
                set(result, `deliveryToRecipientArrivalFact.fake`, true);
                index++;
            }

        }
        return result
    }

    const getNameCargo = (itemTracking, trackingInfo) => {
        const id = itemTracking.orderDeliveryRequestGroup?.id;
        const cargoInfo = itemTracking.orderDeliveryRequestGroup?.cargoInfo;
        const order = itemTracking.orderDeliveryRequestGroup?.order
        const cargo = (cargoInfo?.containers ? cargoInfo.containers : cargoInfo?.generals ? cargoInfo.generals : [order?.cargo?.vehicle]).filter(cargo => cargo.idCargo === trackingInfo?.idCargo)[0]
        if (cargoInfo?.containers) {
            const types = {
                1: "20\"",
                2: "40\"",
                3: "40\"HC",
            }
            return `${id} / ${cargo?.containerId ? cargo.containerId : "-"} - ${get(types, cargo?.typeId)}`
        }
        if (cargoInfo?.generals) {
            let name = translate("form.field.general")
            if (itemTracking.orderDeliveryRequestGroup?.awbNumber)
                name = `${itemTracking.orderDeliveryRequestGroup?.awbNumber}`
            if (itemTracking.orderDeliveryRequestGroup?.containerNumber)
                name = `${itemTracking.orderDeliveryRequestGroup?.containerNumber}`
            if (itemTracking.orderDeliveryRequestGroup?.bol)
                name = `${itemTracking.orderDeliveryRequestGroup?.bol}`
            return id + " / " + name
            if (cargo?.typeId !== undefined) {
                const typeId = {
                    1: "cargoType.box",
                    2: "cargoType.pallet",
                    3: "cargoType.cube"
                }
                let formatSize = `${cargo?.length ? cargo?.length : '-'} x ${cargo?.width ? cargo?.width : '-'} x ${cargo?.height ? cargo?.height : '-'} (${cargo?.sizeUnit}) - ${cargo?.weight} ${cargo?.weightUnit}`
                if (cargo.typeId === 3) {
                    formatSize = `${cargo.cubeVolume ? cargo.cubeVolume : "-"} ${cargo.sizeUnit} - ${cargo?.weight} ${cargo?.weightUnit}`
                }
                return `${id} / ${translate({id: `${typeId[cargo.typeId]}`})} - ${cargo?.amount} ${translate({id: "detailsOfCalculation.pieces"})} - ${formatSize}`
            }
        }
        if (order?.cargo?.vehicle) {
            const bodyType = VEHICLE_BODY_TYPE.find(v => v.value === cargo?.bodyType)?.message
            return `${id} / ${translate({id: `cargoType.car`})} - ${cargo?.type?.name ? getExistLangValue(cargo?.type?.name) : ''} - ${translate({id: `constants.${bodyType}`})}`
        }
        return "-"
    }

    const prepareItems = async (data) => {
        const id = data?.orderDeliveryRequestGroup?.id
        setFake(data?.orderDeliveryRequestGroup?.fake)
        const fake = data?.orderDeliveryRequestGroup?.fake;
        setDeliveryTracking(data)
        const items = data?.trackingInfoItems;
        const array = [];
        let index = 0;
        for (let trackingInfoItem of items) {
            array.push({
                nameCargo: getNameCargo(data, trackingInfoItem),
                idCargo: trackingInfoItem?.idCargo,
                orderId: id,
                statusId: trackingInfoItem?.status,
                ...(await prepareTrackingInfo(trackingInfoItem?.trackingInfo, id, trackingInfoItem?.status, index, fake))
            })
            index++;
        }
        setData(array)
    }

    useEffect(() => {
        if (id) {
            orderDeliveryService.getTrackingInfo(id).then(res => {
                if (res.code === 200) {
                    prepareItems(res.data);
                }
            });
        }
    }, [id])

    const initColumns = (addId = '') => {
        const array = [];
        const statusColumn = getStatusColumn('statusId', addId);
        const firstElement = data[0];
        if (firstElement) {
            const keys =  Object.keys(firstElement).filter((key)=> !["orderId", "status", "nameCargo", "idCargo"].includes(key));
            keys.forEach((key, index) => {
                const isLast = index >= keys.length - 2;
                const obj = get(firstElement, key);
                if (obj)
                    array.push(getTrackingDateKeyColumn(key, key, addId, isLast))
            })
        }

        array.push(statusColumn)
        return array.filter(item => item !== null);
    }

    useEffect(() => {
        if (data?.length > 0) {
            setColumns(initColumns())
            setColumnsModal(initColumns('modal'))
        }
    }, [data])


    const GutterColumn = (props) => {
        const {rowIndex, keyAdd} = props
        const [onHover, setOnHover] = useState(false)
        const [idField, setIdField] = useState(`gutter-cell-${rowIndex}-${keyAdd}`)


        return <div className={"dsg-cell-gutter-custom"}>
            <div id={idField}
                 onPointerEnter={() => setOnHover(true)}
                 onPointerLeave={() => setOnHover(false)}
                 className={"dsg-cell-gutter-custom__data"}>
                <div>
                    {data[rowIndex]?.nameCargo}
                </div>
            </div>
            {document.getElementById(idField) &&
                <Popover
                    isOpen={onHover}
                    target={idField}>
                    <PopoverBody>
                        <div>
                            {data[rowIndex]?.nameCargo}
                        </div>
                    </PopoverBody>
                </Popover>
            }

        </div>
    }

    const DateTrackingInputColumn = (props) => {
        const {
            rowData,
            setRowData,
            rowIndex,
            name = '',
            focus,
            active,
            stopEditing,
            disabled,
            addId,
            data = [],
            initData
        } = props
        const [disabledField, setDisabledField] = useState(false)
        const [copyData, setCopyData] = useState(null)
        const [value, setValue] = useState(rowData?.date?.split(" ")[0])
        const [idField, setIdField] = useState(`element-edit-table-${rowIndex}-${name}`)
        const [idFieldLabel, setIdFieldLabel] = useState(`element-edit-table-label-${rowIndex}-${name}`)


        useEffect(() => {
            setIdField(`element-edit-table-${rowIndex}-${name}_${addId}`)
            setIdFieldLabel(`element-edit-table-label-${rowIndex}-${name}_${addId}`)
        }, [name, addId])
        const ref = useRef(null)
        const refLabel = useRef(null)

        useEffect(() => {
            setValue(rowData?.value)
        }, [rowData])


        useEffect(() => {
            setCopyData(initData)
        }, [initData])

        useEffect(() => {
        }, [active, focus])

        useEffect(() => {
            if (name === "id") {
                setDisabledField(true)
            } else {
                setDisabledField(disabled)
            }
        }, [data, disabled])

        const onChangeValueOld = (val) => {
            if (isEqual(val, rowData?.date)) return

            if (val && val.length>0) {
                if (name === "pointOfPickupReadyPlan" || name === "pointOfPickupReadyFact") {
                    let pointOfPickupReady = deliveryTracking.trackingInfoItems[rowIndex]?.trackingInfo?.pointOfPickup.ready;
                    if (name === "pointOfPickupReadyPlan")
                        pointOfPickupReady.plan = val;
                    if (name === "pointOfPickupReadyFact")
                        pointOfPickupReady.fact = val;
                    OrderDeliveryService.recalculateTrackingDate(id, pointOfPickupReady, deliveryTracking.trackingInfoItems[rowIndex]?.idCargo, false).then(res => {
                        if ((res.status === 'success')) {
                            FlashStore.successNow(translate({id: 'common.save.success'}), true);
                            prepareItems(res.data);
                        }
                    });
                } else {
                    if (name.includes("Plan")) {
                        const old = rowData?.value;
                        let newData = cloneDeep(copyData);
                        set(newData, rowData.path, val);
                        const path = rowData?.path.replace(`trackingInfoItems[${rowIndex}].`, '').split('.');
                        const state = {deliveryTrackingInfo: newData};
                        let newState = shiftPlanDates(val, old, path[1], path[2], state, false, newData.trackingInfoItems[rowIndex].trackingInfo, rowIndex, newData.trackingInfoItems[rowIndex].idCargo)
                        updateRow(newState?.deliveryTrackingInfo.trackingInfoItems[rowIndex])
                    } else {
                        let newData = cloneDeep(copyData);
                        set(newData, rowData.path, val);
                        updateRow(newData.trackingInfoItems[rowIndex])

                    }
                }

            } else {
                let newData = cloneDeep(copyData);
                newData[rowIndex] = set(newData[rowIndex], name, '');
                updateRow(newData[rowIndex], rowIndex)
            }
            stopEditing({nextRow: false})
            setRowData(val)
        }

        const onChangeValueFake = (val) => {
            if (isEqual(val, rowData?.date)) return

            if (val && val.length>0) {
                if (name === "pointOfPickupReadyPlan" || name === "pointOfPickupReadyFact") {
                    let pointOfPickupReady = deliveryTracking.trackingInfoItems[rowIndex]?.trackingInfo?.transitPoints[0].ready;
                    if (name === "pointOfPickupReadyPlan")
                        pointOfPickupReady.plan = val;
                    if (name === "pointOfPickupReadyFact")
                        pointOfPickupReady.fact = val;
                    OrderDeliveryService.recalculateTrackingDate(id, pointOfPickupReady, deliveryTracking.trackingInfoItems[rowIndex]?.idCargo, false).then(res => {
                        if ((res.status === 'success')) {
                            FlashStore.successNow(translate({id: 'common.save.success'}), true);
                            prepareItems(res.data);
                        }
                    });
                } else {
                    if (name.includes("Plan") === true) {
                        if (rowData?.fake === true) {
                            const old = rowData?.value;
                            let newData = cloneDeep(copyData);
                            set(newData, rowData.path, val);
                            const path = rowData?.path.replace(`trackingInfoItems[${rowIndex}].`, '').split('.');
                            const indexTransitPoint = Number.parseInt(path[1].replace("transitPoints[", "").replace("]", ""));
                            const state = {deliveryTrackingInfo: newData};
                            const newState = shiftPlanesDatesFake(val, old, path[2], path[3], state, false, newData.trackingInfoItems[rowIndex].trackingInfo, rowIndex, indexTransitPoint, newData.trackingInfoItems[rowIndex].idCargo);
                            updateRow(newState?.deliveryTrackingInfo.trackingInfoItems[rowIndex])
                        }
                    } else {
                        let newData = cloneDeep(copyData);
                        set(newData, rowData.path, val);
                        updateRow(newData.trackingInfoItems[rowIndex])
                    }
                }
            } else {
                let newData = cloneDeep(copyData);
                set(newData, rowData.path, '');
                updateRow(newData.trackingInfoItems[rowIndex])
            }
            stopEditing({nextRow: false})
            setRowData(val)
        }


        const onChangeValue = (val) => {
            if (fake === false) {
                onChangeValueOld(val);
            } else {
                onChangeValueFake(val);
            }
        }

        useEffect(() => {
            if (focus) {
                ref?.current?.focus()
            } else {
                ref?.current?.blur()
            }
        }, [focus]);

        useEffect(() => {
            if (focus === false) {
                onChangeValue(value)
            }
        }, [focus])

        const _onChangeValue = (value) => {
            setValue(value)
        }

        if (disabledField === true)
            return <div id={idFieldLabel} className={"h-100 d-flex align-items-center"}>
                <div style={{
                    padding: "5px",
                    fontSize: "12px",
                    lineHeight: "14px"
                }}>{(!value || value.length === 0) ? "-" : ""}{value ? moment(value).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]):""}</div>
                {document.getElementById(idFieldLabel) && active && rowData?.name &&
                    <Popover
                        className={addId ? "z-index-9999 blue-popover" : "blue-popover"}
                        placement="top"
                        isOpen={active || focus}
                        target={idFieldLabel}>
                        <PopoverBody>
                            <div>{getExistLangValue(rowData?.name)}</div>
                        </PopoverBody>
                    </Popover>
                }
            </div>


        return <div className={`f-element small no-border d-flex h-100`}>
            <div id={idField}>
                <input
                    id={idFieldLabel}
                    ref={refLabel}
                    className={`${focus ? 'd-none' : ''} raw-input-date ${checkDisabledDate(name, rowIndex, rowData) ? 'disabled' : ''} ${rowData?.indicator} `}
                    placeholder={AppStore.userLang === "ru" ? "дд/мм/гггг" : "yyyy-mm-dd"}
                    value={value ? moment(value).format(AppStore.userLang === "ru" ? "DD/MM/YYYY" : DATE_FORMAT[AppStore.userLang][0]) : undefined}
                />
                <input

                    ref={ref}
                    className={`${focus ? '' : 'd-none'} raw-input-date ${checkDisabledDate(name, rowIndex, rowData) ? 'disabled' : ''} ${rowData?.indicator} `}
                    value={value}
                    onChange={(e) => checkDisabledDate(name, rowIndex, rowData) ? () => {
                    } : _onChangeValue(e.target.value)}
                    type={"date"}

                />
            </div>
            {document.getElementById(idField) && rowData?.name &&
                <Popover
                    className={addId ? "z-index-9999 blue-popover" : "blue-popover"}
                    placement="top"
                    isOpen={active || focus}
                    target={idField}>
                    <PopoverBody>
                        <div>{getExistLangValue(rowData?.name)}</div>
                    </PopoverBody>
                </Popover>
            }
        </div>
    }

    const StatusColumn = React.memo((props) => {
        const {
            rowData,
        } = props

        return (
            <div style={{padding: "5px", fontSize: "12px", lineHeight: "14px"}}>
                <div
                    className={`status-label status-label-${rowData.toString().toLowerCase()}`}>{getOrderStatusName(rowData)}</div>
            </div>
        )
    })

    const getFormatColumnTitle = (key = "", isLast) => {
        if (key.includes("transitPoint")) {
            const element = get(data[0], `${key}.name`)
            let type = "";
            if (key.includes("ArrivalPlan"))
                type = translate({id: "tableTracking.arrivalPlan"});
            else if (key.includes("DeparturePlan"))
                type = isLast===true?translate({id: "tableTracking.dateOfEndPlan"}):translate({id: "tableTracking.departurePlan"});
            else if (key.includes("ArrivalFact"))
                type = translate({id: "tableTracking.arrivalFact"});
            else if (key.includes("DepartureFact"))
                type = isLast===true?translate({id: "tableTracking.dateOfEndFact"}): translate({id: "tableTracking.departureFact"});

            return getExistLangValue(element).substring(0, 25) + `${getExistLangValue(element).length > 24 ? "..." : ""}` + ` (${type})`
        }
        if(key.includes("pointOfDestination")){
            if (key.includes("DeparturePlan")){
                return isLast===true?<FormattedMessage id="tableTracking.dateOfEndPlan"/>:<FormattedMessage id={`orderTable.header.${key}`}/>;
            }else if(key.includes("DepartureFact")){
                return isLast===true?<FormattedMessage id="tableTracking.dateOfEndFact"/>:<FormattedMessage id={`orderTable.header.${key}`}/>;
            }
        }
        return <FormattedMessage id={`orderTable.header.${key}`}/>;
    }

    const getTrackingDateKeyColumn = (key, mapName, addId = "", isLast) => {

        return keyColumn(key, {
            keepFocus: true,
            component: (p) => <DateTrackingInputColumn {...p} initData={deliveryTracking} data={data} mapName={mapName}
                                                       addId={addId}
                                                       name={key}/>,
            title: getFormatColumnTitle(key, isLast),
            minWidth: 120,
            copyValue: ({rowData}) => onCopyValueDateTracking(rowData),
            pasteValue: ({
                             rowData,
                             value,
                             rowIndex
                         }) =>{
                if(checkDisabledDate(key, rowIndex, rowData)){
                    return rowData;
                } else {
                    return {
                        ...rowData,
                        value: value?.length > 0 ? moment(value, "DD.MM.YYYY").format("YYYY-MM-DD") : value
                    }
                }
            },
            deleteValue: ({rowData, rowIndex})=>checkDisabledDate(key, rowIndex, rowData)?rowData:{...rowData, value:''},
            disabled: ({rowData, rowIndex}) => checkDisabledDate(key, rowIndex, rowData)
        })
    }


    const getStatusColumn = (key, addId = "") => {
        return keyColumn(key, {
            component: (p) => <StatusColumn {...p} addId={addId} name={key}/>,
            title: <FormattedMessage id={`orderTable.header.${key}`}/>,
            minWidth: 200,
            copyValue: ({rowData}) => onCopyValueText(rowData),
            pasteValue: ({
                             rowData,
                             value,
                             rowIndex
                         }) => rowData,
            disabled: true
        })
    }


    const fullScreenTitle = () => {
        return <div>
            <div className={"d-flex justify-content-between"}>
                <h2 className={"tracking-header"}><FormattedMessage id={"logistBlock.cargoTracking"}/></h2>
                <div className={"d-flex actions-table-tracking"}>
                    <div className={"d-block ml-3"}
                         onClick={() => setIsModal(false)}>
                        <FontAwesome name={"compress"}/>
                    </div>
                </div>
            </div>
        </div>
    }


    const getBody = (isModal) => {
        return (<DynamicDataSheetGrid
            ref={tableEditRef}
            className={"table-orders"}
            columns={isModal ? columnsModal : columns}
            onChange={onChange}
            addRowsComponent={createAddRowsComponent()}
            gutterColumn={{
                basis: 240,
                component: (p) => <GutterColumn {...p} keyAdd={isModal ? 'modal' : ''}/>
            }}
            value={data}
            height={isModal === true ? (window.innerHeight - 160) : 800}
            headerRowHeight={80}
            contextMenuComponent={React.memo((props) => {
                return null
            })
            }
            rowHeight={isModal === true ? Math.max(Math.min((window.innerHeight - 200 - 60) / data.length, 60), 40) : 40}
        />)
    }

    return (
        <div>
            <Preloader isShow={blockEdit}/>
            <div className={"d-flex justify-content-end"}>
                <div onClick={() => setIsModal(true)} className={"cursor-pointer"}>
                    <FontAwesome name={"expand"}/>
                </div>
            </div>
            <div>
                {getBody()}
            </div>
            <div>
                <Modal
                    className={"table-tracking-modal fullscreen-modal"}
                    onClose={() => setIsModal(false)}
                    isShow={isModal}
                    isModal={true}
                    title={fullScreenTitle()}
                >
                    {getBody(true)}
                </Modal>
            </div>
        </div>
    )

};

TrackingDateTableEdit.propTypes = {};

export default TrackingDateTableEdit;